import isArray from 'lodash/isArray';
import find from 'lodash/find';

function unescape(token) {
	return token.replace(/~1/g, '/').replace(/~0/g, '~').replace(/~2/g, '@');
}

function escape(token) {
	return token.replace(/~/g, '~0').replace(/\//g, '~1').replace(/@/g, '~2');
}

export default class Pointer {
	constructor(tokens = ['']) {
		this.tokens = tokens;
	}

	/**
	 * `path` *must* be a properly escaped string.
	 *
	 * @param {string} path
	 * @returns {Pointer}
	 */
	static fromJSON(path) {
		const tokens = path.split('/').map(unescape);
		if (tokens[0] !== '') {
			throw new Error(`Invalid JSON Pointer: ${path}`);
		}
		return new Pointer(tokens);
	}

	toString() {
		return this.tokens.map(escape).join('/');
	}

	toArray() {
		return this.tokens;
	}

	/**
	 * Returns an object with 'parent', 'key', and 'value' properties.
	 * In the special case that pointer = "", parent and key will be null, and `value = obj`
	 * Otherwise, parent will be the such that `parent[key] == value`
	 *
	 * @param {Object} object
	 * @returns {{parent: Object|null, key: string|null, value: any}}
	 */
	evaluate(object) {
		/** @type {Object|null} parent */
		let parent = null;
		/** @type {string|null} token */
		let token = null;
		for (let i = 1, l = this.tokens.length; i < l; i++) {
			parent = object;
			token = this.tokens[i];

			// not sure if this the best way to handle non-existent paths...
			object = (parent || {})[token];

			// try by id property
			if (!object && token.slice(0, 1) === '@' && isArray(parent)) {
				const id = token.slice(1);
				object = find(
					parent || {},
					(child) => child && String(child.id) === String(id)
				);
			}
		}
		return {
			parent: parent,
			key: token,
			value: object,
		};
	}

	push(token) {
		// mutable
		this.tokens.push(token);
	}

	/**
	 * @param {string} token
	 * @returns {Pointer}
	 */
	add(token) {
		const tokens = this.tokens.concat(String(token));
		return new Pointer(tokens);
	}
}
